import React from 'react';
import { Modal, Button } from 'antd';
import { history } from '../../container/History'

const NesaRegistrationsInfoModal = (props) => {

    const gotoPurchaseMembership = () => {
        props.closeInfoVisiblePopup();
          history.push('/purchase-membership')
    }

    return (
        <div>
            <Modal
                centered
                className='NesaMembershipModal'
                visible={props.InfoVisible}
                closable={false}
                title="Welcome to National Eagle Scout Association"
                footer={[
                    <div className="NesaMembershipModalFooter" >
                        <div className="CancelNesaMembershipAction">
                            <Button key="back" className="CancelNesaMembershipModal" onClick={props.closeInfoVisiblePopup}>
                                Cancel
                            </Button>
                        </div>
                        <div className="NESAMembershipActions">
                            {/* {this.renderViewNesaStatusButton()} */}

                            <Button key="submit" type="primary" className="GoToPurchaseNesaMembership" onClick={gotoPurchaseMembership}>
                                Purchase Membership
                            </Button>
                        </div>
                    </div>
                ]}
            >
                Did you know NESA members empower Scouting's mission and protect the Eagle Scout legacy for future generations?
                Membership gives your Eagle pride a purpose. If you are not a member, please join today.


                    <div className='note-text'>
                        NOTE: You do not have any current NESA membership
                    </div>
            </Modal>
        </div>
    );
};

export default NesaRegistrationsInfoModal;


// WEBPACK FOOTER //
// ./src/components/Inc/NesaRegistationInfoModal.js